import type { LucideIcon } from "lucide-react"
import {
  BadgePercentIcon,
  DownloadIcon,
  LayoutDashboardIcon,
  MapPinnedIcon,
  PackageIcon,
  UserRoundCogIcon,
} from "lucide-react"

export interface AccountNavigationItem {
  href: string
  icon: LucideIcon
  label: string
}

export const accountNavigationItems: AccountNavigationItem[] = [
  {
    href: "/minha-conta",
    icon: LayoutDashboardIcon,
    label: "Painel",
  },
  {
    href: "/minha-conta/pedidos",
    icon: PackageIcon,
    label: "Pedidos",
  },
  {
    href: "/minha-conta/assinaturas",
    icon: BadgePercentIcon,
    label: "Assinaturas",
  },
  {
    href: "/minha-conta/downloads",
    icon: DownloadIcon,
    label: "Downloads",
  },
  {
    href: "/minha-conta/enderecos",
    icon: MapPinnedIcon,
    label: "Enderecos",
  },
  {
    href: "/minha-conta/detalhes-da-conta",
    icon: UserRoundCogIcon,
    label: "Detalhes da conta",
  },
] as const
